module.exports = __webpack_public_path__ + "static/panel-a6b4e683bd6a55be5e6c8bc35d8c2a0c.png";